import { render, staticRenderFns } from "./FormatRecords.vue?vue&type=template&id=117d3456&"
import script from "./FormatRecords.vue?vue&type=script&lang=js&"
export * from "./FormatRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports